import { graphql, usePaginationFragment } from "react-relay";
import { TagListFragment$key } from "./__generated__/TagListFragment.graphql";
import { useTransition } from "react";
import ExpandableList from "./ExpandableList";
import Tag from "./Tag";

const Fragment = graphql`
  fragment TagListFragment on Taggable
  @refetchable(queryName: "TagListFragmentPaginationQuery")
  @argumentDefinitions(
    cursor: { type: "String" }
    count: { type: "Int", defaultValue: 5 }
  ) {
    tagList: tags(first: $count, after: $cursor)
      @connection(key: "TagListFragment_tagList") {
      totalCount
      edges {
        node {
          id
          ...TagFragment
        }
      }
    }
  }
`;

export interface TagListProps {
  taggable: TagListFragment$key;
  noExpand?: boolean | undefined;
}

export default function TagList({ taggable, noExpand }: TagListProps) {
  const [inTransition, startTransition] = useTransition();
  const {
    data: { tagList },
    loadNext,
  } = usePaginationFragment(Fragment, taggable);

  if (tagList.edges.length <= 0) {
    return null;
  }

  return (
    <ExpandableList
      total={tagList.totalCount}
      isExpanding={inTransition}
      noExpand={noExpand}
      onExpand={() =>
        startTransition(() => {
          loadNext(tagList.totalCount - tagList.edges.length);
        })
      }
    >
      {tagList.edges.map(({ node }) => (
        <li key={node.id}>
          <Tag tag={node} />
        </li>
      ))}
    </ExpandableList>
  );
}
